/**
 * Каталог: страница секции.
 *
 * - Интеграция с ProductFiltersManager и ProductLoadingManager
 * - AJAX-перезагрузка списка товаров при смене фильтров (/project/get/products)
 * - Load more кнопка
 */

import { apiRequest, APIError } from '../../api.js';

let loadingManager = null;

function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

async function loadProductsWithFilters(filters) {
    const categoryId = document.querySelector('input[name="category_id"]')?.value || 0;
    const isWishlist = document.querySelector('input[name="is_wishlist"]')?.value || 0;

    const requestData = {
        cat_id: parseInt(categoryId, 10),
        is_wishlist: parseInt(isWishlist, 10),
        modal: 0,
    };

    if (filters.categories?.length) requestData.category = filters.categories;
    if (filters.subcategories?.length) requestData.subcategory = filters.subcategories;
    if (filters.materials?.length) requestData.material = filters.materials;
    if (filters.brands?.length) requestData.brand = filters.brands;
    if (filters.tags?.length) requestData.tags = filters.tags;

    if (loadingManager) loadingManager.showLoading();

    try {
        const response = await apiRequest('/project/get/products', {
            method: 'POST',
            body: requestData,
        });

        if (response && response.html_products) {
            if (loadingManager) {
                loadingManager.updateProducts(response.html_products);
            } else {
                const list = document.querySelector('.js_products-list');
                if (list) list.innerHTML = response.html_products;
            }
        } else {
            console.error('Section: invalid products response');
            if (loadingManager) loadingManager.hideLoading();
        }
    } catch (e) {
        console.error('Section: loading error:', e);
        if (loadingManager) loadingManager.hideLoading();
        const msg = e instanceof APIError ? e.message : 'Error loading products. Please try again.';
        window.showToast?.('error', msg);
    }
}

function initPagination() {
    const button = document.querySelector('#section_pagination_button');
    const totalPages = parseInt(document.querySelector('input[name=qty_pages]')?.value || '0', 10);
    let pageCounter = 1;

    document.addEventListener('click', e => {
        if (!e.target.closest('#section_pagination_button')) return;

        pageCounter++;
        if (pageCounter >= totalPages && button?.parentElement) {
            button.parentElement.style.display = 'none';
        }
    });
}

function init() {
    if (!document.querySelector('.product_list_catalog_outer')) return;

    if (typeof window.ProductLoadingManager !== 'undefined') {
        loadingManager = new window.ProductLoadingManager({
            containerSelector: '.product_list_catalog_outer',
            productsSelector: '.js_products-list',
        });
    }

    if (document.getElementById('product_list_filter') && typeof window.ProductFiltersManager !== 'undefined') {
        new window.ProductFiltersManager({
            context: 'catalog',
            filterId: 'product_list_filter',
            currentCategoryId: 0,
            onFilterChange: filters => loadProductsWithFilters(filters),
        });
    }

    initPagination();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// Использую csrf-токен через apiRequest, явного доступа не нужно; функция оставлена для
// совместимости с внешним кодом, если кто-то читал window.getCsrfToken.
window.getCsrfToken ??= getCsrfToken;
